import { useContext } from "react";
import { TokenContext } from "../context/TokenContext";

const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  const { token, setToken } = context;
  return { token, setToken };
};

export default useToken;